export default __webpack_public_path__ + "static/media/eletric6.b788765a.jpeg";